import React from 'react';
import logoLgBlack from '../../images/logo-lg-black100.png';
import './FooterSection.css';

const FooterSection = (props) => {
  let currentDateYear =  new Date().getFullYear();
   return (
     <div className="FooterSection-container">
      <footer>
        <div class="centered clearfix">
          <div class="FooterSection--logo-container">
            <img class="logo FooterSection--logo" src={logoLgBlack} alt="logo" style={{width:100}}/>
          </div>
          {/* <div class="footer-contact">
            <h3><a href="">Contact</a></h3>
            <p><a href="mailto:info@realtimetouch.com">Email Us</a></p>
            <p><a href="tel:">123-456-7890</a></p>
            <p><a href="">123 Adams St<br />San Diego, CA 92126</a></p>
          </div> */}
          <div class="footer-navigation">
            <div class="footer-links-holder">
              {/* <h3><a href="">Social Media</a></h3> */}
              <ul class="footer-links">
                <li><a href="https://twitter.com/realtimetouch/">Twitter</a></li>
                <li><a href="https://www.facebook.com/realtimetouch/">Facebook</a></li>
                <li><a href="https://www.linkedin.com/company/realtimetouch/">LinkedIn</a></li>
                <li><a href="https://www.realtimetouch.com/videos">YouTube</a></li>
              </ul>
            </div>
            <div class="footer-links-holder">
              {/* <h3><a href="">Website</a></h3> */}
              <ul class="footer-links">
                <li><a href="/contact/">Contact</a></li>
                <li><a href="http://archive.realtimetouch.com/">Archived Site</a></li>
                <li><a href="/updates/">Updates</a></li>
                <li><a href="/">What is Real Time Touch?</a></li>
              </ul>
            </div>
            <div class="footer-links-holder">
              {/* <h3><a href="">Business</a></h3> */}
              <ul class="footer-links">
                <li><a href="/market/">Growing Market</a></li>
                <li><a href="/applications/">Applications</a></li>
                <li><a href="/faq/">FAQ</a></li>
                {/* <li><a href="/statistics/">Recent Statistics</a></li> */}
                <li><a href="/patents/">Patents</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="bottom-bar">
            All Rights Reserved © 1999-{ currentDateYear } | <a href="/privacy/">Privacy Policy</a> | <a href="/terms/">Terms of Service</a>
        </div>
        
      </footer>
     </div>
   )
 }

 export default FooterSection;



// WEBPACK FOOTER //
// ./src/containers/FooterSection/FooterSection.js